<template>
  <div class="rule-display">
    <div class="rule-display">
      <div class="row">
        <div
          v-if="lookbackWindow"
          class="col-12 col-md-4">
          <h4>{{ capitalize(i18n.t('names.lookbackWindow')) }}</h4>
          <span
            data-testid="geofenceLoookbackWindowDescription"
            class="text-muted">
            {{ lookbackWindow.description }}
          </span>
        </div>
        <div
          v-if="s3Path"
          class="col-12 col-md-8">
          <h4>{{ capitalize(i18n.t('names.s3Path')) }}</h4>
          <span class="text-muted">
            {{ s3Path }}
          </span>
        </div>
      </div>
      <div v-if="daypart">
        <h4>{{ capitalize(i18n.t('names.daypart')) }}</h4>
        <daypart-viewer
          class="mt-2"
          :daypart="daypart" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize, computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import DaypartViewer from '@/common/components/controls/DaypartViewer.vue';
  import AudienceLookBackWindow from '@/common/models/audience/AudienceLookBackWindow';
  import AudienceRule from '@/common/models/audience/AudienceRule';

  const i18n = useI18n();
  const props = defineProps<{
    rule: AudienceRule;
    reach?: number;
    cpm?: number;
  }>();

  const lookbackWindow = computed<AudienceLookBackWindow>(() => props.rule.audienceLookbackWindow);
  const s3Path = computed<string | undefined>(() => props.rule.audienceRuleCustomGroup?.s3Path);
  const daypart = computed<string | undefined>(() => (props.rule.isCustomDaypart ? props.rule.daypart : undefined));
</script>

<style lang="scss" scoped>
  .rule-display {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  h4,
  p {
    margin: 0 !important;
  }
  h4 {
    font-size: 1.33rem;
    font-weight: 600;
  }
</style>
